"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreativeFormatAttribute = void 0;
const CreativeFormatAspectRatio_1 = require("./CreativeFormatAspectRatio");
const CreativeFormatFastStart_1 = require("./CreativeFormatFastStart");
const CreativeFormatPlaybackTime_1 = require("./CreativeFormatPlaybackTime");
class CreativeFormatAttribute {
    constructor({ aspectRatio, playbackTime, fastStart, }) {
        this.toJSON = () => ({
            aspectRatio: this.aspectRatio && this.aspectRatio.toJSON(),
            playbackTime: this.playbackTime && this.playbackTime.toJSON(),
            fastStart: this.fastStart && this.fastStart.toJSON(),
        });
        this.aspectRatio = aspectRatio;
        this.playbackTime = playbackTime;
        this.fastStart = fastStart;
    }
}
exports.CreativeFormatAttribute = CreativeFormatAttribute;
CreativeFormatAttribute.fromJSON = (json) => {
    const { aspectRatio, playbackTime, fastStart } = Object.assign({}, json);
    const _aspectRatio = aspectRatio ? CreativeFormatAspectRatio_1.default.fromJSON(aspectRatio) : undefined;
    const _playbackTime = playbackTime ? CreativeFormatPlaybackTime_1.default.fromJSON(playbackTime) : undefined;
    const _fastStart = fastStart ? CreativeFormatFastStart_1.default.fromJSON(fastStart) : undefined;
    return new CreativeFormatAttribute({
        aspectRatio: _aspectRatio,
        playbackTime: _playbackTime,
        fastStart: _fastStart,
    });
};
exports.default = CreativeFormatAttribute;
